import tw, { css } from 'twin.macro'

const baseStyle = css`
  ${tw`min-h-160 md:min-h-140 lg:min-h-175 xl:min-h-220 py-18 md:py-20 xl:py-36 relative`}
`

export default baseStyle
